import { Link } from "react-router-dom";

const SideNavbaBarDashboard = () => {
    return (
                 <>
                    <div className="col-lg-3">
                        <div className="wrap-sidebar-account">
                            <ul className="my-account-nav">
                               
                                <li><Link to="/orders" className="my-account-nav-item">Orders</Link></li>
                                <li><Link to="/address" className="my-account-nav-item">Address</Link></li>
                                <li><Link to="/accountdetails" className="my-account-nav-item">Account Details</Link></li>
                              
                            </ul>
                        </div>
                        
                    </div>

                    <div className="offcanvas offcanvas-start canvas-filter canvas-sidebar canvas-sidebar-account" id="mbAccount">
        <div className="canvas-wrapper">
            <header className="canvas-header">
                <span className="title">SIDEBAR ACCOUNT</span>
                <span className="icon-close icon-close-popup" data-bs-dismiss="offcanvas" aria-label="Close"></span>
            </header>
            <div className="canvas-body sidebar-mobile-append"><ul className="my-account-nav">
                               
                               <li><Link to="/orders" className="my-account-nav-item">Orders</Link></li>
                               <li><Link to="/address" className="my-account-nav-item">Address</Link></li>
                               <li><Link to="/accountdetails" className="my-account-nav-item">Account Details</Link></li>
                             
                           </ul> </div>
        </div>       
    </div>

                    </>
             
    )
}

export default SideNavbaBarDashboard;